export type GlossaryEntries = {
  [key: string]: GlossaryEntry[]
}



export type GlossaryEntry = {
  descr: string, voce: string,identifier:string
}

export type ServiceResponse<T> = {
  status: string
  message?: string
  errors?: string[]
  data: T
}

export type StatDataDTO = {
  descrizione: string
  valore: number
  link?: string
  property: string
}

export class TopTenDataDTO {
  confezioni!: TopTenItem[]
  medicinali!: TopTenItem[]
}

export class StatItemDisplay {
  title: string;
  iconName: string;
  link?: string;
  onTheMarketValue: number;
  authorizedValue: number;


  constructor(title: string, iconName: string, link: string | undefined, onTheMarketValue: number, authorizedValue: number) {
    this.title = title;
    this.iconName = iconName;
    this.link = link;
    this.onTheMarketValue = onTheMarketValue;
    this.authorizedValue = authorizedValue;
  }

}

export type StatsDisplay = {
  [key: string]: StatItemDisplay;
}

export interface Response {
  data: Farmaco;
  statur: number;
}

export interface Farmaco {
  id: string;
  principiAttiviIt: string[];
  confezioni: Confezione[];
  medicinale: Medicinale;
  vieSomministrazione: string[];
  codiceAtc: string[];
  descrizioneAtc: string[];
  formaFarmaceutica: string;
  pianoTerapeutico: number;
  descrizioneFormaDosaggio: string;
  flagAlcol: number;
  flagPotassio: number;
  flagGuida: number;
  flagDopante: number;
  livelloGuida: any;
  descrizioneLivello: any;
  carente: number;
  innovativo: number;
  orfano: number;
  revocato: number;
  sospeso: number;
  principioAttivoForma: PrincipioAttivoForma[];
  flagFI: true;
  flagRCP: true;
  aic6ImportazioneParallela: number;
  denImportazioneParallela: string;
  ragImportazioneParallela: string;
  sisImportazioneParallela: number;
  tipoAutorizzazione: string;
}

export interface Confezione {
  idPackage: string;
  denominazionePackage: string;
  descrizioneFornitura: any;
  classeFornitura: string;
  codiceFormaDosaggio: string;
  aic: string;
  descrizioneRf: string[];
  carenzaMotivazione: any;
  carenzaInizio: any;
  carenzaFinePresunta: any;
  dataAutorizzazione: string;
  flagCommercio: number;
  flagPrescrizione: number;
  carente: number;
  vieSomministrazione: string[];
  classeRimborsabilita: string;
  descrizioneRimborsabilita: string;
  statoAmministrativo: string;
  descrizioneStatoAmministrativo: string;
  dataRegistrazioneGU: string;
  dataRicezionePratica: string;
  pianoTerapeutico: any;
  fkFormaDosaggio: any;
}

export interface Medicinale {
  codiceMedicinale: string;
  aic6: number;
  denominazioneMedicinale: string;
  codiceSis: number;
  aziendaTitolare: string;
}

export interface PrincipioAttivoForma {
  principioAttivo: string[];
  formaFarmaceutica: string;
  flagDopante: number;
}

export type TopTenItem = {
  [key in 'aic6' | 'aic9']: string;
} & {
  nome: string;
  nomeTitolare: string;
  data: Date;
  nomeConfezione:string;
}
